import 'bootstrap'
import "magnific-popup";
import AOS from "aos";
import "scrollit";
import "jquery-validation";

(function ($) {
    "use strict";
    /**
     * ----------------------------------------------
     * Animatation plugin AOS call
     * ----------------------------------------------
     */
    AOS.init({
        offset: 150,
        duration: 400,
        easing: 'linear',
        delay: 0,
        once: true,
        disable: 'mobile'
    });

    /**
     * ----------------------------------------------
     * Scroll to section
     * ----------------------------------------------
     */
    $.scrollIt({
        upKey: 38,             // key code to navigate to the next section
        downKey: 40,           // key code to navigate to the previous section
        easing: 'linear',      // the easing function for animation
        scrollTime: 600,       // how long (in ms) the animation takes
        activeClass: 'active', // class given to the active nav element
        onPageChange: null,    // function(pageIndex) that is called when page is changed
        topOffset: -50           // offste (in px) for fixed top navigation
    });

    /**
     * ----------------------------------------------
     * sidebar menu call
     * ----------------------------------------------
     */
    sidebarMenu();

    /**
     * ----------------------------------------------
     * Portfolio photoswipe image slider call
     * ----------------------------------------------
     */
    photoswipe();

    /**
     * ----------------------------------------------
     * Contact us form validation
     * ----------------------------------------------
     */
    validateContactUsForm();


    /**
     * ----------------------------------------------
     * Get started form validation
     * ----------------------------------------------
     */
    validateGetStartedForm();

    /**
     * ----------------------------------------------
     * SVG Animation cALL
     * ----------------------------------------------
     */
    svgAnimation();

    initJqueryElementMovement();

})(jQuery);


/**
 * ----------------------------------------------
 * sidebar menu
 * ----------------------------------------------
 */
function sidebarMenu() {
    $(".sidebar-btn").on("click", function () {
        $(".sidebar-menu").addClass("active");
    })
    $(".sidebar-menu .close-sidebar").on("click", function () {
        $(".sidebar-menu").removeClass("active");
    });
    $(".sidebar-right-btn").on("click", function () {
        var href = $(this).attr('data-href');
        $(href).addClass("active");
    })
    $(".sidebar-open-nav .close-sidebar").on("click", function () {
        var href = $(this).attr('data-href');
        $(href).removeClass("active");
    })
}

/**
 * ----------------------------------------------
 * Portfolio photoswipe image slider
 * ----------------------------------------------
 */
function photoswipe() {
    if ($("#gallery").length) {
        var items = [],
            $pswp = $('.pswp')[0],
            $folioItems = $('.filtr-item');

        // get items
        $folioItems.each(function (i) {

            var $folio = $(this),
                $thumbLink = $folio.find('.grid-image > a'),
                $title = $folio.find('.grid-title'),
                $caption = $folio.find('.pswp-caption'),
                $titleText = '<h4>' + $.trim($title.html()) + '</h4>',
                $captionText = $.trim($caption.html()),
                $href = $thumbLink.attr('href'),
                $width = 1920,
                $height = 700;

            var item = {
                src: $href,
                w: $width,
                h: $height
            }

            if ($caption.length > 0) {
                item.title = $.trim($titleText + $captionText);
            }

            items.push(item);
        });

        $('.filtr-item').on('click', function (e) {
            e.preventDefault();
            var options = {
                index: parseInt($(this).attr("data-index")) - 1,
                showHideOpacity: true
            }
            // initialize PhotoSwipe
            var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
            lightBox.init();
        });
    }
}

/**
 * ----------------------------------------------
 * Validate contact us form data
 * ----------------------------------------------
 */
function validateContactUsForm() {
    if ($('#validation-form').length) {
        $('#validation-form').validate({
            focusInvalid: false,
            rules: {
                'validation-email': {
                    required: true,
                    email: true
                },
                'validation-firstname': {
                    required: true,
                },
                'validation-lastname': {
                    required: true,
                },
                'validation-phone': {
                    required: true,
                },
                'validation-message': {
                    required: true,
                },
                'validation-required': {
                    required: true
                }
            },

            // Errors
            //

            errorPlacement: function errorPlacement(error, element) {
                var $parent = $(element).parents('.form-group');

                // Do not duplicate errors
                if ($parent.find('.jquery-validation-error').length) {
                    return;
                }

                $parent.append(
                    error.addClass('jquery-validation-error small form-text invalid-feedback')
                );
            },
            highlight: function (element) {
                var $el = $(element);
                var $parent = $el.parents('.form-check');
                if ($parent.length > 0) {
                    $parent.addClass('is-invalid');
                } else {
                    $el.addClass('is-invalid');
                }
                // Select2 and Tagsinput
                if ($el.hasClass('select2-hidden-accessible') || $el.attr('data-role') === 'tagsinput') {
                    $el.parent().addClass('is-invalid');
                }
            },
            unhighlight: function (element) {
                $(element).parents('.form-check').removeClass('is-invalid');
            },
            submitHandler: function (form) {
                var url = "index.php";
                $.ajax({
                    type: "POST",
                    url: url,
                    data: $(form).serialize(),
                    success: function (data) {
                        $("#message").html(data);
                        $("#message").fadeIn();
                        $("#message").removeClass('d-none');
                        document.getElementById("validation-form").reset();
                        setTimeout(function () {
                            $("#message").fadeOut();
                            $("#message").addClass('d-none');
                        }, 4000)
                    }
                });
            }
        });
    }
}

/**
 * ----------------------------------------------
 * Validate get started form data
 * ----------------------------------------------
 */
function validateGetStartedForm() {
    if ($('#get-started-form').length) {
        $('#get-started-form').validate({
            focusInvalid: false,
            rules: {
                'validation-email': {
                    required: true,
                    email: true
                },
                'validation-fullname': {
                    required: true,
                },
                'validation-mobile': {
                    required: true,
                },
                'validation-message': {
                    required: true,
                },
                'validation-required': {
                    required: true
                }
            },

            // Errors
            //

            errorPlacement: function errorPlacement(error, element) {
                var $parent = $(element).parents('.form-group');

                // Do not duplicate errors
                if ($parent.find('.jquery-validation-error').length) {
                    return;
                }

                $parent.append(
                    error.addClass('jquery-validation-error small form-text invalid-feedback')
                );
            },
            highlight: function (element) {
                var $el = $(element);
                var $parent = $el.parents('.form-check');
                if ($parent.length > 0) {
                    $parent.addClass('is-invalid');
                } else {
                    $el.addClass('is-invalid');
                }
                // Select2 and Tagsinput
                if ($el.hasClass('select2-hidden-accessible') || $el.attr('data-role') === 'tagsinput') {
                    $el.parent().addClass('is-invalid');
                }
            },
            unhighlight: function (element) {
                $(element).parents('.form-check').removeClass('is-invalid');
            }
        });
    }
}

/**
 * ----------------------------------------------
 * SVG Animation
 * ----------------------------------------------
 */
function svgAnimation() {
    if ($(".svg-animation").length) {
        new Vivus('my-svg1', {
            type: 'sync',
            duration: 100,
        }, function () {
            setTimeout(function () {
                $("#my-svg1").parents('.svg-object').next().addClass('show');
                $("#my-svg2").parents('.svg-object').addClass('show')
                new Vivus('my-svg2', {type: 'sync', duration: 100},
                    function () {
                        setTimeout(function () {
                            $("#my-svg2").parents('.svg-object').next().addClass('show');
                            $("#my-svg3").parents('.svg-object').addClass('show')
                            new Vivus('my-svg3', {type: 'sync', duration: 100},
                                function () {
                                    setTimeout(function () {
                                        $("#my-svg3").parents('.svg-object').next().addClass('show');
                                        $("#my-svg4").parents('.svg-object').addClass('show')
                                        new Vivus('my-svg4', {type: 'sync', duration: 100});
                                    }, 100)
                                }
                            );
                        }, 100)
                    }
                );
            }, 100)
        })
    }
}

function initJqueryElementMovement() {
    jQuery.fn.extend({
        // Modified and Updated by MLM
        // Origin: Davy8 (http://stackoverflow.com/a/5212193/796832)
        parentToAnimate: function (newParent, duration) {
            duration = duration || 'slow';

            var $element = $(this);

            newParent = $(newParent); // Allow passing in either a JQuery object or selector
            var oldOffset = $element.offset();
            var oldWidth = $element.width();
            var oldHeight = $element.height();
            $(this).appendTo(newParent);
            var newOffset = $element.offset();
            var newWidth = $element.width();
            var newHeight = $element.height();

            var temp = $element.clone().removeAttr('id').appendTo('body');

            temp.css({
                'position': 'absolute',
                'left': oldOffset.left,
                'top': oldOffset.top,
                'width': oldWidth,
                'height': oldHeight,
                'zIndex': 100000
            });

            $element.hide();

            return temp.animate({
                'top': newOffset.top,
                'left': newOffset.left,
                'width': newWidth,
                'height': newHeight
            }, duration)
                .promise()
                .then(function () {
                    $element.show();
                    temp.remove();
                });
        }
    });
}

export default function initFormAnimation(form) {
    form.find(".moving-label-input").on("blur input focus", function () {
        const label = $(this).closest(".field").find("label");
        if (this.value) {
            label.addClass("form-upper-label");
        } else {
            label.removeClass("form-upper-label");
        }
    }).on("focus", function () {
        const label = $(this).closest(".field").find("label");
        if (this) {
            label.addClass("form-upper-label");
        } else {
            label.removeClass("form-upper-label");
        }
    });
}
